import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import styled from 'styled-components';
import map from 'lodash/map';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Arrow } from '../../../images/arrow_down.svg';
const { Option } = Select;

const SelectStyle = styled(Select)`
  &&& {
    .ant-select-selector {
      border: none;
      box-shadow: none;
      &:hover,
      &:active {
        border: none;
        box-shadow: none;
      }
    }
    .ant-select-selection-item {
      font-weight: 600;
      color: black;
      font-size: 14px;
    }
  }
`;

function SelectStorages({
  data,
  getDevices,
  filter,
  setSelect,
  stateSearch,
  limit,
}) {
  const { t } = useTranslation();
  console.log(stateSearch);
  const handleChange = (value) => {
    setSelect(value);
    if (value !== '') {
      if (
        filter &&
        (filter.oldVersion ||
          filter.errorSync ||
          filter.notAtt ||
          filter.att ||
          filter.offline ||
          filter.online)
      ) {
        getDevices({
          outdated: filter.oldVersion ? 1 : null,
          synchronized: filter.errorSync ? 0 : null,
          box_id__is_null: [filter.notAtt ? 1 : null, filter.att ? 0 : null],
          online: [filter.online ? 1 : null, filter.offline ? 0 : null],
          warehouse_id: value,
          serial: stateSearch ? stateSearch : null,
        });
      } else {
        getDevices({
          warehouse_id: value,
          limit,
          serial: stateSearch ? stateSearch : null,
        });
      }
    } else {
      if (
        filter &&
        (filter.oldVersion ||
          filter.errorSync ||
          filter.notAtt ||
          filter.att ||
          filter.offline ||
          filter.online)
      ) {
        getDevices({
          outdated: filter.oldVersion ? 1 : null,
          synchronized: filter.errorSync ? 0 : null,
          box_id__is_null: [filter.notAtt ? 1 : null, filter.att ? 0 : null],
          online: [filter.online ? 1 : null, filter.offline ? 0 : null],
          serial: stateSearch ? stateSearch : null,
        });
      } else {
        getDevices({ limit, serial: stateSearch ? stateSearch : null });
      }
    }
  };
  return (
    <>
      <SelectStyle
        onChange={handleChange}
        suffixIcon={
          <div>
            <Arrow />
          </div>
        }
        defaultValue={t('storages')}
        className="w-full bg-white shadow-standart rounded-md flex h-45 items-center justify-center text-graytext relative"
      >
        <Option value="">{t('storages')}</Option>
        {map(data, (item) => {
          return (
            <Option key={item.id} value={item.id}>
              {item.name}
            </Option>
          );
        })}
      </SelectStyle>
    </>
  );
}

SelectStorages.propTypes = {};

export default SelectStorages;
